import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate() {
    const isAuthenticated$ = this.authService.isAuthenticated();

    isAuthenticated$.subscribe(authenticated => {
      if (!authenticated) {
        this.router.navigate([ '/login' ]);
      }
    });

    return isAuthenticated$;
  }
}
